import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { NegotiationEditModalService } from 'src/app/services/negotiation-edit-modal/negotiation-edit-modal.service';
import { NegotiationsService } from 'src/app/services/negotiations/negotiations.service';
import { UserService } from 'src/app/services/user/user.service';
import { SearchableSelectOption } from 'src/app/shared/components/searchable-select/searchable-select.component';
import Swal from 'sweetalert2';
declare var bootstrap: any;

@Component({
  selector: 'app-negotiation-edit',
  templateUrl: './negotiation-edit.component.html',
  styleUrls: ['./negotiation-edit.component.scss']
})
export class NegotiationEditComponent extends DestructorComponent implements OnInit {

  @Output() negotiationUpdated = new EventEmitter<void>();

  negotiationForm!: FormGroup;
  isLoading = false;
  selectedNegotiation: any = null;

  // Dropdown options
  salesPersonList: SearchableSelectOption[] = [];
  statusOptions = [
    { value: 'pending', label: 'Pending' },
    { value: 'cancelled', label: 'Cancelled' },
    { value: 'completed', label: 'Completed' }
  ];

  constructor(
    private fb: FormBuilder,
    private negotiationEditModalService: NegotiationEditModalService,
    private negotiationsService: NegotiationsService,
    private userService: UserService
  ) {
    super();
    this.initializeForm();
  }

  ngOnInit(): void {
    this.loadSalesPersonList();
    this.setupModalListener();
  }

  private initializeForm(): void {
    this.negotiationForm = this.fb.group({
      status: ['', Validators.required],
      sales_person: ['']
    });
  }

  private setupModalListener(): void {
    const modalElement = document.getElementById('kt_modal_negotiation_edit');
    if (modalElement) {
      modalElement.addEventListener('shown.bs.modal', () => {
        const negotiation = this.negotiationEditModalService.getSelectedNegotiation();
        if (negotiation) {
          this.selectedNegotiation = negotiation;
          this.populateForm(negotiation);
        }
      });

      modalElement.addEventListener('hidden.bs.modal', () => {
        this.negotiationEditModalService.clearSelectedNegotiation();
        this.resetForm();
      });
    }
  }

  private loadSalesPersonList(): void {
    this.subscriptions.push(
      this.userService.GetData('1', '', { role_type: 30, paginate: 'false' }).subscribe({
        next: (response: any) => {
          if (response.status && response.data) {
            const salesPersons = Array.isArray(response.data) ? response.data : response.data.data || [];
            this.salesPersonList = salesPersons.map((person: any) => ({
              value: person._id || person.doc_id || '',
              label: `${person.title || ''} ${person.name || ''}`.trim()
            }));
          }
        },
        error: (error) => {
          console.error('Error loading sales person list:', error);
          this.salesPersonList = [];
        }
      })
    );
  }

  private populateForm(negotiation: any): void {
    this.negotiationForm.patchValue({
      status: negotiation.status || '',
      sales_person: negotiation?.sales_person_id || ''
    });
  }

  private resetForm(): void {
    this.negotiationForm.reset();
    this.selectedNegotiation = null;
  }

  onSubmit(): void {
    if (this.negotiationForm.invalid || !this.selectedNegotiation) {
      return;
    }

    this.isLoading = true;
    console.log('Loading state set to:', this.isLoading);
    const formData = this.negotiationForm.value;

    this.subscriptions.push(
      this.negotiationsService.UpdateData(this.selectedNegotiation._id, formData).subscribe({
        next: (response) => {
          this.isLoading = false;
          if (response.status) {
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Negotiation updated successfully',
              timer: 2000,
              showConfirmButton: false
            });
            this.closeModal();
            this.negotiationUpdated.emit();
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: response.message || 'Failed to update negotiation'
            });
          }
        },
        error: (error) => {
          this.isLoading = false;
          console.error('Error updating negotiation:', error);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'An error occurred while updating the negotiation'
          });
        }
      })
    );
  }

  closeModal(): void {
    const modalElement = document.getElementById('kt_modal_negotiation_edit');
    if (modalElement) {
      const modal = bootstrap.Modal.getInstance(modalElement);
      if (modal) {
        modal.hide();
      }
    }
  }
}
